var layout_default = {
  "layout": "aaVLs",
  "cell": "_2Bd5r"
};
export {
  layout_default as default
};
//# sourceMappingURL=layout-scss.js.map
